/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/confidential'>.
 * ссылка из куки-баннера
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import ConfidentialPolicy from '@routes/StaticPages/LegalPages/ConfidentialPolicy';

export const Route = createFileRoute('/confidential')({
  component: () => (
    <CacheDataRoute component={ConfidentialPolicy} path='/confidential' />
  )
});
